import React from 'react';
import {
  Box,
  Typography,
  Card,
  CardContent,
  Grid,
  Paper,
  Button,
  Divider,
  List,
  ListItem,
  ListItemText,
  Chip
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const prescription = {
  cost: 15250,
  hmoCover: 15250,
  contribution: 0,
  pickups: [
    { qty: 1, location: 'MedPlus, Aboyade Cole Street, Victoria Island.' },
    { qty: 4, location: 'MedPlus, Aboyade Cole Street, Victoria Island.' },
    { qty: 3, location: 'HealthLand, Awolowo Road, Ikoyi, Lagos' }
  ],
  medications: [
    { name: 'Azithromycin 250 mg tablet' },
    { name: 'Medrol (Pak) 4 mg tablets in a dose pack' },
    { name: 'Doxycycline hyclate 100 mg capsule' }
  ],
  dosage: [
    {
      date: 'May 11, 2025',
      items: [
        { name: 'Azithromycin #1', details: '250 mg tablet, 1 daily', time: '10.00am' },
        { name: 'Paracetamol #1', details: '250 mg tablet, 1 daily', time: '10.00am' },
        { name: 'Azithromycin #1', details: '250 mg tablet, 1 daily', time: '6.00pm' },
        { name: 'Paracetamol #1', details: '250 mg tablet, 1 daily', time: '6.00pm' }
      ]
    }
  ]
};

export default function ViewPrescription() {
  return (
    <Box p={2}>
      <Button startIcon={<ArrowBackIcon />} sx={{ mb: 2 }} color="success">
        View Prescription
      </Button>

      <Typography variant="h6" fontWeight={600} color="green" gutterBottom>
        Pick Up
      </Typography>

      {prescription.pickups.map((pickup, idx) => (
        <Paper
          key={idx}
          elevation={1}
          sx={{ p: 2, mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <Typography fontWeight={600}>*********** x {pickup.qty}</Typography>
          <Typography variant="body2">{pickup.location}</Typography>
          <LocationOnIcon color="success" />
        </Paper>
      ))}

      <Box my={1}>
        <Typography variant="body2" fontWeight={600}>
          Med. Cost: ₦{prescription.cost.toLocaleString()} | HMO Cover: ₦{prescription.hmoCover.toLocaleString()} |
          Contribution: ₦{prescription.contribution.toLocaleString()}
        </Typography>
      </Box>

      <Paper variant="outlined" sx={{ my: 2 }}>
        <CardContent>
          <Typography fontWeight={600} color="green" gutterBottom>
            Prescription List
          </Typography>
          <Grid container spacing={1} fontWeight={600} sx={{ mb: 1 }}>
            <Grid item xs={1}>S/N</Grid>
            <Grid item xs={11}>Name</Grid>
          </Grid>
          {prescription.medications.map((med, i) => (
            <Grid container spacing={1} key={i}>
              <Grid item xs={1}>{i + 1}</Grid>
              <Grid item xs={11}>{med.name}</Grid>
            </Grid>
          ))}
        </CardContent>
      </Paper>

      <Box my={2}>
        <Typography fontWeight={600} color="green">
          Additional Note
        </Typography>
        <Paper variant="outlined" sx={{ p: 2, minHeight: 100, mt: 1 }}>
          {/* Add notes here if available */}
        </Paper>
      </Box>

      <Box my={3}>
        <Typography fontWeight={600} color="green" gutterBottom>
          Dosage
        </Typography>
        {prescription.dosage.map((day, i) => (
          <Paper key={i} sx={{ mb: 2 }} variant="outlined">
            <Box display="flex" alignItems="center" gap={1} p={1} bgcolor="#f1fdf1">
              <CalendarMonthIcon fontSize="small" color="success" />
              <Typography fontWeight={600}>{day.date}</Typography>
            </Box>
            <List>
              {day.items.map((dose, j) => (
                <ListItem
                  key={j}
                  sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #eee' }}
                >
                  <ListItemText primary={dose.name} secondary={dose.details} />
                  <Chip label={dose.time} color="success" />
                </ListItem>
              ))}
            </List>
          </Paper>
        ))}
      </Box>

      <Button fullWidth variant="text" color="success" startIcon={<CalendarMonthIcon />}>
        View Prescription Details
      </Button>
    </Box>
  );
}
